import { useCallback } from 'react';
import { PageNames, SITE_ID, LANGUAGE_DOMAIN } from '../adobeDataLayer';

export { PageNames };

export const useAdobeDataLayer = () => {
  const sendPageView = useCallback((pageName) => {
    const adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer = adobeDataLayer;

    window.adobeDataLayer.push({
      event: 'PAGEVIEW',
      metadata: {
        allow_marketing: false,
        site_id: SITE_ID,
        language_domain: LANGUAGE_DOMAIN,
        platform: 'Adobe App Builder',
      },
      page: {
        name: pageName,
        url:
          window.location.host +
          window.location.pathname +
          window.location.search +
          window.location.hash,
      },
      user: {
        alt_customer_id: null,
        authentication_status: 'Unauthenticated',
      },
    });
  }, []);

  return { sendPageView };
};
